import {
  GET_TAGS_PAGINATED,
  UPDATE_TAG,
} from '../../actions/types';

const _ = require('lodash');

const initalizeState = {
  tags:      [],
  loading:   true,
  updatedAt: new Date(),
  error:     {},
};

export default function (state = initalizeState, action) {
  const { type, payload } = action;
  let tagsCloned = _.cloneDeep(state.tags);

  switch (type) {
    case GET_TAGS_PAGINATED:
      return {
        ...state,
        tags:    payload.rows,
        loading: false,
      };
    case UPDATE_TAG:
      tagsCloned = tagsCloned.filter((tag) => tag.name !== payload.name);
      return {
        ...state,
        tags:      [...tagsCloned, payload],
        loading:   false,
        updatedAt: new Date(),
      };
    default:
      return state;
  }
}
